import React from 'react';

export default function AlertRoundedIcon({
  size = 25,
  variant = 'primary', 
  background = '#FFFFFF',
  borderColor,
  badgeColor,
  markColor = '#FFFFFF',
  className,
  title,
  ...props
}) {
  const variants = {
    primary: { border: '#5062F0', badge: '#F2B90D' },
    muted:   { border: '#9296AC', badge: '#D0D3E2' }
  };

  const palette = variants[variant] || variants.primary;
  const stroke = borderColor || palette.border;
  const badge  = badgeColor || palette.badge;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={title}
      {...props}
    >
      {title ? <title>{title}</title> : null}

      <rect x="0.5" y="0.5" width="24" height="24" rx="3.5" fill={background} />
      <rect x="0.5" y="0.5" width="24" height="24" rx="3.5" stroke={stroke} />

      <rect x="4.5" y="4.5" width="16" height="16" rx="8" fill={badge} />

      <path
        d="M13.2005 7.824V11.256C13.2005 11.62 13.1825 11.978 13.1465 12.33C13.1105 12.678 13.0645 13.048 13.0085 13.44H12.0005C11.9445 13.048 11.8985 12.678 11.8625 12.33C11.8265 11.978 11.8085 11.62 11.8085 11.256V7.824H13.2005ZM11.5745 15.684C11.5745 15.56 11.5965 15.442 11.6405 15.33C11.6885 15.218 11.7525 15.122 11.8325 15.042C11.9165 14.962 12.0145 14.898 12.1265 14.85C12.2385 14.802 12.3585 14.778 12.4865 14.778C12.6105 14.778 12.7285 14.802 12.8405 14.85C12.9525 14.898 13.0485 14.962 13.1285 15.042C13.2125 15.122 13.2785 15.218 13.3265 15.33C13.3745 15.442 13.3985 15.56 13.3985 15.684C13.3985 15.812 13.3745 15.932 13.3265 16.044C13.2785 16.152 13.2125 16.246 13.1285 16.326C13.0485 16.406 12.9525 16.468 12.8405 16.512C12.7285 16.56 12.6105 16.584 12.4865 16.584C12.3585 16.584 12.2385 16.56 12.1265 16.512C12.0145 16.468 11.9165 16.406 11.8325 16.326C11.7525 16.246 11.6885 16.152 11.6405 16.044C11.5965 15.932 11.5745 15.812 11.5745 15.684Z"
        fill={markColor}
      />
    </svg>
  );
}
